import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { OrderService } from '@app/cp/shared/services/order.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { VendorCreditItemsComponent } from './vendor-credit-items/vendor-credit-items.component';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { VendorCreditBus } from '@app/cp/shared/models/VendorCreditBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { OrderItemsSelectComponent } from './order-item-select/order-item-select.component';
import { OrderDetailsSelectBus } from '@app/cp/shared/models/OrderDetailsSelectBus';
import { OrderBus } from '@app/cp/shared/models/OrderBus';
import { VendorCreditItemsBus } from '@app/cp/shared/models/VendorCreditItemsBus';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { CommonValues } from '../../../shared/static/CommonValues';
import { Subscription } from 'rxjs';
import { IFeatureFlagSet, UseFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { CmProAuthService } from '@app/core/services';
import { InvoiceService } from '../../../shared/services/invoice.service';

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'vendor-credits',
    templateUrl: './vendor-credits.component.html',
    styleUrls: ['./vendor-credits.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VendorCreditsComponent extends BaseEditComponent<VendorCreditBus, OrderService, null, null>  {
    compLoader: ICPLoader = this as any;
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    _invoiceService: InvoiceService;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: OrderService, private authService: CmProAuthService, invoiceService: InvoiceService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.setParam();
        this.readOnly = false;
        this.saveMode = SaveMode.all;
        this.className = "VendorCreditBus";
        this.appCode = "Vendor Credit";
        this._invoiceService = invoiceService;
    }
    @ViewChild("LineItems") lineItemsComponent: VendorCreditItemsComponent;
    @ViewChild('orderItemSelect') orderItemSelect: OrderItemsSelectComponent;
    orderId: any = null;
    public minDate: Date = new Date(2000, 0, 1);
    public maxDate: Date =new Date((Date.now()));
    orderBillId: any = null;
    canNotCreateCreditReason: string = "";
    popUp: boolean = false;
    creating: boolean = false;
    parts: any[];
    get f() { return this.editForm.controls; }
    get fv() { return this.hasEditForm ? this.editForm.value : null; }
    vendorCreditNumber: string = "";
    //order number for the order associated with the credit
    @Input() poNumber: string = "";
    @Output() invoiceCreated: EventEmitter<any> = new EventEmitter();
    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'vendorCreditId': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'creditDate': new UntypedFormControl(null,Validators.required),
        'supplierId': new UntypedFormControl(null,Validators.required),
        'credit': new UntypedFormControl(0,Validators.required),
        'refNo': new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
        'memo': new UntypedFormControl('',Validators.maxLength(500)),
        'vendorCreditStatusId': new UntypedFormControl(null,Validators.required),
        'insertUserId': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'invoiceNumber': new UntypedFormControl()
    });
    setForm() {
        this.editForm.patchValue({
            vendorCreditId: this.data.vendorCreditId,
            companyId: this.data.companyId,
            creditDate: this.data.creditDate,
            supplierId: this.data.supplierId,
            credit: this.data.credit,
            refNo: this.data.refNo,
            memo: this.data.memo,
            vendorCreditStatusId: this.data.vendorCreditStatusId,
            insertUserId: this.data.insertUserId,
            insertDt: this.data.insertDt,
            updateUserId: this.data.updateUserId,
            updateDt: this.data.updateDt,
            invoiceNumber: this.data.invoiceNumber
        });
        this.canNotCreateCreditReason = this.data.canNotCreateCreditReason
        this.setPristine();
    }
    ngOnInit() {
        this.setupCheckForm();
        this.maxDate.setMonth(this.maxDate.getMonth() + 12);
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });

    }
    ngOnDestroy() {
        this.subs_VendorStatusChange.unsubscribe();
    }
    itemGridHeaderMsg: string = "Please note: Vendor Credit must be in Received Status to add/edit Items";
    canEditLines: boolean = false;
    subs_VendorStatusChange: Subscription;
    setupCheckForm() {
        this.subs_VendorStatusChange = this.editForm.get('vendorCreditStatusId')?.valueChanges.subscribe((value: string) => {
            if (value === CommonValues.VendorCredit_StatusReceived || value === CommonValues.VendorCredit_StatusForReview) {
                this.canEditLines = true;
            } else {
                this.canEditLines = false;
            }
        });
    }
    get supplierId(): any {
        return this.hasEditForm ? this.editForm.value.supplierId : null;
    }
    get hasSupplierId(): boolean {
        return CommonFunctions.hasGuidValue(this.supplierId);
    }
    get searchPrompt(): string {
        return this.hasSupplierId ? "Supplier Credit Search" : "Enter Supplier In Order To Search";
    }
    vendorCreditSearch: boolean = false;

    doVendorCreditSearch(e: any) {
        if (this.hasSupplierId) {
            this.setParam();
        }
        else {
            this.setParam();
            if (this.hasEditForm) {
                this.editForm.controls["supplierId"].markAsTouched;
                this.editForm.controls["supplierId"].markAsDirty;
            }
        }
        this.vendorCreditSearch = true;
    }
    customFormValidation() {
        let vcIsValid: boolean = true;
        let errorMsg: string = "";
        if (this.editForm.value && (this.editForm.value.credit !== this.lineItemsComponent.getTotal 
                && (this.editForm.value.vendorCreditStatusId !== CommonValues.VendorCredit_StatusForReview 
                        && this.editForm.value.vendorCreditStatusId !== CommonValues.VendorCredit_StatusInvalidMatch))) {
            errorMsg = "Credit Amount", "The credit items are not equal to the credit amount";
            vcIsValid = false;
        }
        return vcIsValid;
    }
    cancel() {
        super.cancel();
        this.forcePartsSelectRefresh = true;
        this.readOnly = false;
    }
    getDataForCancel() {
        return this.createNew(null);
    }
    getData() {
        this.subs_data = this.svc_data.getVendorCredit(this.id).subscribe(
            {
                next:
                    (info: BaseMessageInfo) => {
                        if (!info.saveError) {
                            let busObj: VendorCreditBus = new VendorCreditBus(info.primaryReturn);

                            let arr = [];
                            if (CommonFunctions.hasArrayValue(busObj.vendorCreditItems)) {
                                for (let i = 0; i < busObj.vendorCreditItems.length; i++) {
                                    let newObj: VendorCreditItemsBus = new VendorCreditItemsBus(busObj.vendorCreditItems[i]);
                                    arr.push(newObj);
                                }
                            }
                            busObj.vendorCreditItems = arr
                            this.setData(busObj);

                            this.edit();
                            this.creating = false;
                        }
                    },
                error: (err) => {
                    console.error(err);
                    this.globals.notifyError(`An error occurred while retrieving data. Error: ${err?.message}`, true);
                }
        });

    }
    seParam: CommonParam;
    includeClosed: boolean = false;
    public includeClosedChanged(e: any) {
        this.setParam();
    }
    setParam() {
        this.seParam = new CommonParam();
        this.seParam.addParam("IncludeClosed", this.includeClosed);
        this.seParam.addParam("OrderId", this.orderId ? this.orderId : null);
        this.seParam.addParam("SupplierId", this.hasEditForm ? this.editForm.value.supplierId : null);

        this.seParam.addParam("RecAfter", new Date('1/1/2021'));
    }
    vendorCreditSelected(value: any) {
        this.vendorCreditSearch = false;
        if (value != null) {
            this.id = value.VendCrId;
            this.getData();
        }
    }
    clear() {
        super.clear();
        this.forcePartsSelectRefresh = true;
        this.orderId = null;
        this.orderData = null;
    }
    saveAll() {
        this.compLoader.cpLoader = true;
        let now: Date = DateFunctions.getDateNow();

        let busObj: VendorCreditBus = new VendorCreditBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.setBeforeSave();
        busObj.orderBillId = this.orderBillId;
        busObj.orderId = this.orderId;
        busObj.vendorCreditItems = _.cloneDeep(this.lineItemsComponent.getAll());
        busObj.deletedItems = _.cloneDeep(this.lineItemsComponent.getDeletedItems());
        this.svc_data.saveVendorCredit(busObj).subscribe(
            {
                next: (info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        if (this.editForm) {
                            this.editForm.markAsPristine();
                        }
                        this.saveSuccess();
                    }
                    else {
                        this.saveError(info.message);
                    }
                    if (info.warning) {
                        this.globals.notifyWarning(info.message);
                    }
                    this.compLoader.cpLoader = false;
                },
                error: (err) => {
                    console.error(err);
                    this.globals.notifyError('There was an error saving the Supplier Credit');
                    this.compLoader.cpLoader = false;
                }
            }
        );
    }
    createCustomerCredit() {
        this.compLoader.cpLoader = true;
        this.creating = true;
        let now: Date = DateFunctions.getDateNow();

        let busObj: VendorCreditBus = new VendorCreditBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.setBeforeSave();

        this._invoiceService.createCreditMemoCRZuggit(busObj.vendorCreditId).subscribe(
            {
                next: (info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        if (this.editForm) {
                            this.editForm.markAsPristine();
                        }
                        this.saveSuccess();
                        this.invoiceCreated.emit(info.primaryReturn);
                    }
                    else {
                        this.saveError(info.message);
                    }
                    if (info.warning) {
                        this.globals.notifyWarning(info.message);
                    }
                    this.compLoader.cpLoader = false;
                    this.creating = false;
                },
                error: (err) => {
                    console.error(err);
                    this.globals.notifyError('There was an error saving the Supplier Credit');
                    this.compLoader.cpLoader = false;
                }
            }
        );
    }

    orderData: OrderBus;
    getOrderData() {
        this.svc_data.getFromId(this.orderId).subscribe(data => {
            this.orderData = new OrderBus(data);
            this.data.supplierId = this.orderData.supplierId;
            if(this.compFeatureFlagSet.featureFlagSet["ui-vendor-credit-memo-readonly"] && 
                (!CommonFunctions.hasValue(this.data.memo) || CommonFunctions.isEmptyChar(this.data.memo))) {
                    this.data.memo = this.poNumber;
            }
            this.setForm();
            this.setParam();
        });
    }
    forcePartsSelectRefresh: boolean = false;
    selectedParts: any;
    ///////////////////////////////
    //Passes InvoiceId or Lines?
    ///////////////////////////////
    setup(data: any, orderBillId: any) {
        this.orderId = data;
        this.orderBillId = orderBillId;
        this.setParam();
        this.data = this.createNew(null);
        this.data.vendorCreditStatusId = CommonValues.VendorCredit_StatusForReview;
        this.data.vendorCreditItems = [];
        if (CommonFunctions.hasValue(data)) {
            this.getOrderData();
        }
        this.readOnly = false;
        this.creating = false;
    }
    selectPartsActive: boolean = false;
    openPartsSelect() {
        this.selectPartsActive = true;
        this.orderItemSelect.setup(this.orderId, (this.forcePartsSelectRefresh || !!this.globals.user.isZuggitUser) ,this.orderBillId);
        this.forcePartsSelectRefresh = false;
    }
    hidePartsSelected() {
        this.selectPartsActive = false;
    }
    onChange(e) {
        if (e && e.getFullYear() > 20 && e.getFullYear() < 100) {
            var adjDate = new Date(e.getFullYear() + 2000, e.getMonth(), e.getDate());
            this.editForm.patchValue({
                creditDate: adjDate,
            });
        }
    }

    closePartsSelected(e: any) {
        let rows: OrderDetailsSelectBus[] = this.orderItemSelect.getSelectedRows();
        this.hidePartsSelected();
        if (CommonFunctions.hasArrayElementValue(rows)) {
            for (let i = 0; i < rows.length; i++) {
                let busObj = rows[i];
                let newBusObj: VendorCreditItemsBus = new VendorCreditItemsBus();
                newBusObj.classId = busObj.accountClassId;
                newBusObj.dispatchId = busObj.dispatchId;
                newBusObj.dispatchNumber = busObj.dispatchNumber;
                newBusObj.invDesc = busObj.inventoryDesc;
                newBusObj.inventoryId = busObj.inventoryId;
                newBusObj.invNumber = busObj.inventoryNumber;
                newBusObj.orderId = busObj.orderId;
                newBusObj.orderNumber = this.orderData.orderNumber;
                newBusObj.quantity = busObj.quantity;
                newBusObj.cost = busObj.price;
                newBusObj.orderDetailId = busObj.orderDetailId;
                newBusObj.isAdded = true;
                newBusObj.insertDt = DateFunctions.getDateTimeNowWithUTCOffset();
                newBusObj.updateDt = DateFunctions.getDateTimeNowWithUTCOffset();
                newBusObj.setId(CommonFunctions.getGuid());
                this.data.addItem(newBusObj);
            }
            this.editForm.markAsDirty();
        }
    }
}

